import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        <p>I specialize in modern web technologies and quality assurance practices.<br></br> My core competencies include building full-stack applications and ensuring they meet the highest standards of reliability.</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={meter1} alt="MERN Stack Progress" />
                                <h5>MERN Stack</h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Software Testing Progress" />
                                <h5>Software Testing</h5>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="React/Node Progress" />
                                <h5>React & Node.js</h5>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="General Testing Progress" />
                                <h5>Manual & Automation Testing</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="" />
    </section>
  )
}
